// Vendors
import { useMutation } from '@tanstack/react-query';

// Src
import { authenticationRefreshToken } from '../api/authenticationAPI';

export default function useRefreshTokenMutation() {
    return useMutation({
        mutationFn: (payload: { refresh_token: string; access_token: string }) => {
            return authenticationRefreshToken(payload.refresh_token, payload.access_token);
        },
    });
}
